import React, { ReactChild } from "react";

export const FooterComponent = ({
  leftTemplate,
  rightTemplate,
}: {
  leftTemplate?: ReactChild;
  rightTemplate?: ReactChild;
}) => {
  return (
    <div className="footer">
      <div className="container d-flex">
        {leftTemplate}
        <div className={"ml-auto"}>{rightTemplate}</div>
      </div>
    </div>
  );
};
